export default __webpack_public_path__ + "static/OpenSansBold-c36d974c9e0bb4429abd3a59187fc89d.svg";